import React from 'react';
import { Row, Col, Card, Button, Modal, Table, Image, Form, FormControl } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faInfoCircle, faCopy } from '@fortawesome/free-solid-svg-icons'
import { saveAs } from 'file-saver';

import '../assets/css/main.css'

import request from '../libs/request';
import Layout from '../component/layout/member';
import Intro from '../component/intro'
import BankLogo from '../component/bank_logo'

const cookies = new Cookies();

const USE_GATEWAY = (process.env.REACT_APP_USE_GATEWAY && process.env.REACT_APP_USE_GATEWAY === 'true') || false

//const CHANNEL_QRCODE = ['TRINITY', 'PROMPTPAY']

class Deposit extends React.Component {
  constructor(props) {
    super(props);

    let data = cookies.get(process.env.REACT_APP_COOKIE_MEMBER);

    this.state = {
      loading: false,
      logined: data ? true : false,
      username: data ? data.username : '',
      system: {},
      member: {},
      logs: [],
      showModal: false,
      intro: null,
      limit: 20,
      deposit_channel: 'qrcode',
      deposit_amount: {},
      deposit_min: 100,
      deposit_limit: { min: 0, max: 20000 },
      pathname: null,
      gateway_payment_channels: [],
      showModalGateway: false,
      gatewayPayment: null,
    }

    this.hideModal = this.hideModal.bind(this);
    this.changeDepositChannel = this.changeDepositChannel.bind(this);
    this.changeDepositAmount = this.changeDepositAmount.bind(this);
    this.submitDeposit = this.submitDeposit.bind(this);
    this.downloadQRCode = this.downloadQRCode.bind(this);
    this.copyText = this.copyText.bind(this);
    this.hideModalGateway = this.hideModalGateway.bind(this);
  }


  componentDidMount() {
    //console.log('this.props.location.pathname', window.location, this.props.location)

    this.setState({ loading: true, pathname: this.props.location.pathname }, () => {

      request.get('page/deposit?limit=' + this.state.limit).then(response => {
        if (response.data && response.data.status_code === 200) {

          let result = response.data;

          this.setState({ loading: false }, () => {

            if (result.success) {
              const system = result.data.system;

              let data = {
                showModal: false,
                member: result.data.member,
                system,
                logs: result.data.logs,
                deposit_limit: result.data.limit,
                intro: result.data.intro,
              }

              //if (system.configuration.message && system.configuration.message.deposit) data.intro = system.configuration.message.deposit;

              /*
              for (const account of system.accounts) {
                if (CHANNEL_QRCODE.indexOf(account.bank.id) === -1) data.showModal = true;
              }
                */

              if (result.data && result.data.payment_channels) {
                data.gateway_payment_channels = result.data.payment_channels || []
                if (data.gateway_payment_channels.length > 0) data.deposit_channel = data.gateway_payment_channels[0]
              }


              if (system.configuration.video && system.configuration.video.deposit) data.video = system.configuration.video.deposit


              this.setState(data);

            }
            else {

              if (result.message.indexOf('permission') !== -1) this.setState({ logined: false })
              else alert(result.message);
            }

          });

        }
        else {
          console.log('Cannot register');
        }
      })

    })
  }


  hideModal() {
    this.setState({ showModal: false }, () => {
    });
  }

  changeDepositChannel(channel) {
    this.setState({ deposit_channel: channel })
  }

  changeDepositAmount(channel, amount) {
    //let amount = e.currentTarget.value || 0;
    let deposit_amount = this.state.deposit_amount || {}
    if (!deposit_amount[channel]) deposit_amount[channel] = 0
    deposit_amount[channel] = amount

    console.log(channel, amount)
    this.setState({ deposit_channel: channel, deposit_amount });
  }

  submitDeposit(bank) {
    const channel = this.state.deposit_channel

    let { deposit_amount, deposit_limit } = this.state

    const amount = deposit_amount[channel] || 0

    if (amount < deposit_limit.min) {
      alert('จำนวนเงินฝากต้องไม่น้อยกว่า ' + deposit_limit.min + ' บาท')
    }
    else if (deposit_limit.max > 0 && amount > deposit_limit.max) {
      alert('จำนวนเงินฝากต้องไม่เกิน ' + deposit_limit.max + ' บาท')
    }
    else {
      //console.log('Bank', bank, this.state.amount)

      //this.setState({ showModalGateway: true, gatewayPayment: { redirect_url: 'http://localhost:5174/deposit/result' } });      return;

      this.setState({ loading: true }, async () => {
        let data = {
          payment_channel: channel,
          amount: amount,
          redirect_url: window.location.href,
        }

        request.post('credit/deposit/' + bank, data).then(response => {
          if (response.data && response.data.status_code === 200) {

            let result = response.data;

            if (result.success) {
              //console.log('data', result.data)

              let data = result.data

              if (data.redirect_url) {

                const win = window.open(data.redirect_url, '_blank')
                if (win) {
                  win.focus()
                }
                else {
                  console.log('Popup ถูกบล็อกโดย browser กรุณากำหนดสิทธิ์ให้สามารถเปิด Popup')
                  window.location.href = data.redirect_url
                  //this.setState({ showModalGateway: true, gatewayPayment: { redirect_url: data.redirect_url } });
                }


              } else {
                this.setState({ showModalGateway: true, gatewayPayment: data });
              }

              this.setState({ deposit_amount: {} })

            }
            else alert(result.message);

            this.setState({ loading: false })
          }
          else {
            alert('ไม่สามารถฝากเงินได้ขณะนี้');
            this.setState({ loading: false })
          }
        })

      })
    }

  }


  downloadQRCode(qrcode) {
    const filename = qrcode.split('/').pop()

    saveAs(qrcode, filename)
  }

  copyText(text) {
    navigator.clipboard.writeText(text)
  }

  hideModalGateway() {
    this.setState({ showModalGateway: false, gatewayPayment: null })
  }



  render() {
    const { loading, logined, username, showModal, system, member, logs, intro, pathname, deposit_limit, showModalGateway, gatewayPayment, deposit_amount, gateway_payment_channels } = this.state;

    const PAYMENT_CHANNEL_LABEL = {
      //qrcode: 'สแกนคิวอาร์โค้ด ฝากได้ทั้งธนาคาร และ ทรู วอเลท',
      qrcode: 'สแกนคิวอาร์โค้ด ฝากได้เฉพาะธนาคารเท่านั้น',
      truewallet: 'ฝาก ทรู วอเลท',
    }

    return (
      <>


        {logined ? (
          <>


            {member.account &&
              <>

                <Layout path={pathname}>
                  <Row className="justify-content-md-center ">
                    <Col sm={12} lg={6} xs={12} >
                      <h3 className="h">เติมเครดิต</h3>
                      <Card className="my-4">
                        <Card.Body>
                          ยินดีต้อนรับ <b style={{ display: 'none' }}>{username}</b>
                          บัญชีของคุณ <strong><span className="text-success ">{member.firstname} {member.lastname}</span></strong>
                          {/*
                          <>
                          <span className="text-success mx-2">{member.account.bank.name} {member.account.number}</span>
                          (<span className="text-success mx-2">{member.firstname} {member.lastname}</span>)
                          </>
                           */}

                        </Card.Body>
                      </Card>

                      <Intro intro={intro} />


                      {(USE_GATEWAY && gateway_payment_channels.length > 0) &&
                        <>
                          {gateway_payment_channels.map((channel, i) => (
                            <Card className="my-1 mb-3" key={i}>
                              <Card.Header>
                                <strong>{PAYMENT_CHANNEL_LABEL[channel] || 'สแกนฝากเงิน ได้ทั้งธนาคาร และทรู วอเลท'}</strong>
                              </Card.Header>
                              <Card.Body className='text-center'>

                                <Row className='mb-2'>
                                  <Col>
                                    <FormControl
                                      type="number"
                                      placeholder={'ระบุจำนวนเงิน' + ((deposit_limit.min > 0) ? ' ขั้นต่ำ ' + deposit_limit.min + ' บาท' : '')}
                                      min={deposit_limit.min}
                                      onChange={(e) => this.changeDepositAmount(channel, e.currentTarget.value || 0)}
                                      value={deposit_amount[channel] ? deposit_amount[channel] || '' : ''}
                                      disabled={loading}
                                      size="lg"
                                    />
                                  </Col>
                                </Row>
                                <Row>
                                  <Col>
                                    <Button className="px-4" variant="success" size='lg' onClick={() => { this.submitDeposit('gateway') }} disabled={loading}>ฝากเงิน</Button>
                                  </Col>
                                </Row>

                                {deposit_limit.min > 0 && <Form.Text muted> {'ขั้นต่ำ ' + deposit_limit.min + ' บาท'}</Form.Text>}
                              </Card.Body>
                            </Card>
                          ))}
                        </>
                      }

                      {(system.accounts) &&
                        <>
                          {system.accounts.map((account, i) => (
                            <>

                              <Card className="my-1 mb-3" key={i} style={{ display: 'none' }}>
                                {account.by &&
                                  <Card.Header>
                                    ต้องโอนด้วย <span className="text-primary">{account.by.bank.name} {account.by.number}</span>
                                  </Card.Header>
                                }
                                <Card.Body>
                                  <Form className="mb-3">
                                    <Form.Group as={Row} className="mb-1">
                                      <Form.Label column sm={4} xs={4} lg={4}>
                                        {(account.bank.id !== 'truewallet') ? 'ธนาคาร' : 'เข้า'}
                                      </Form.Label>
                                      <Col >
                                        <Form.Control className="text-success" plaintext readOnly defaultValue={account.bank.name} />
                                      </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className="mb-1">
                                      <Form.Label column sm={4} xs={4} lg={4}>
                                        {(account.bank.id === 'truewallet') ? 'เบอร์/ID' : 'เลขที่บัญชี'}
                                      </Form.Label>
                                      <Col >
                                        <Form.Control className="text-success" plaintext readOnly defaultValue={account.number} />
                                      </Col>
                                      <Col>
                                        <Button size="sm" variant="outline-info" onClick={() => this.copyText(account.number)}><FontAwesomeIcon icon={faCopy} /> Copy</Button>
                                      </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} >
                                      <Form.Label column sm={4} xs={4} lg={4}>
                                        ชื่อบัญชี
                                      </Form.Label>
                                      <Col >
                                        <Form.Control className="text-success" plaintext readOnly defaultValue={account.name || '-'} />
                                      </Col>
                                    </Form.Group>
                                  </Form>
                                  {(account.qrcode && account.qrcode.show && account.qrcode.url) ? (
                                    <>

                                      <Row>
                                        <Col className="text-center">
                                          <Image src={account.qrcode.url + '?' + Date.now()} className="mb-2" style={{ maxWidth: 250 }} />
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col className="text-center">
                                          <Button className="px-4" variant="outline-info" onClick={() => { this.downloadQRCode(account.qrcode.url + '?' + Date.now()) }} >Save QR Code</Button>
                                        </Col>
                                      </Row>
                                    </>
                                  ) : (

                                    <Row style={{ display: 'none' }}>
                                      <Col xs={3} sm={3} lg={2}>
                                        <BankLogo bank={account.bank.id} />
                                      </Col>
                                      <Col>

                                        <h4>{(account.bank.id !== 'truewallet') ? 'ธนาคาร' : ''} {account.bank.name}</h4>


                                        <>
                                          {(account.bank.id === 'truewallet') ? (
                                            <>
                                              <span>
                                                เบอร์/ID <b className="text-success">{account.number}</b><br />
                                                ชื่อ <b className="text-success">{account.name || '-'}</b>

                                              </span>
                                            </>
                                          ) : (
                                            <>
                                              เลขที่บัญชี <b className="text-success">{account.number}</b> <br />ชื่อบัญชี <b className="text-success">{account.name}</b> <br />
                                            </>
                                          )}
                                        </>


                                      </Col>
                                    </Row>
                                  )}

                                </Card.Body>
                              </Card>
                            </>
                          ))}
                        </>
                      }

                      {(logs.length > 0) &&
                        <Card className="my-2">
                          <Card.Body>
                            <div className="mb-2">
                              <b>{this.state.limit} รายการล่าสุด</b>
                            </div>

                            {loading ? (<FontAwesomeIcon icon={faSpinner} size="3x" spin />) : (

                              <Table striped hover className="table-sm">
                                <thead>
                                  <tr className="text-center">
                                    <th>วันที่</th>
                                    <th >ประเภท</th>
                                    <th>จำนวน</th>
                                    <th >สถานะ</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {logs.map((log, i) => (
                                    <tr key={i} className="text-center">
                                      <td><small>{log.createdAt}</small></td>
                                      <td>{log.type}</td>
                                      <td>{log.credit} บาท</td>
                                      <td><span className={'text-' + log.status.mode}>{log.status.title}</span></td>
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>

                            )}

                          </Card.Body>
                        </Card>
                      }

                    </Col>
                  </Row>

                </Layout>

                <Modal
                  show={showModal}
                  aria-labelledby="contained-modal-title-vcenter"
                  onHide={this.hideModal}
                  centered
                >
                  <Modal.Body className="text-center">

                    <FontAwesomeIcon className="mb-4" icon={faInfoCircle} size="6x" />

                    <h4 className="text-info mb-4">โปรดอ่าน</h4>
                    <p>
                      กรุณาใช้บัญชี </p>
                    {system.accounts.map((account, i) => (
                      <>
                        <p>
                          <b class="text-primary">{account.by.bank.name} {account.by.number}</b><br />
                          โอนเข้า<br />
                          <b class="text-success">{account.bank.name} {account.number}</b>
                        </p>
                        <hr />
                      </>
                    ))}

                    {/*
                    <p><b className="text-success">{member.account.bank.name} {member.account.number}</b>
                      <br />
                      <span className="text-success">{member.firstname} {member.lastname}</span></p>
 */}

                    <p>
                      ในการโอนเงินเท่านั้นไม่เช่นนั้นเครดิตจะไม่เข้าบัญชี หากมีปัญหากรุณาติดต่อทีมงาน
                    </p>
                    <div className="text-center">

                      <Button variant="secondary" className="px-4" onClick={this.hideModal}>ปิด</Button>
                    </div>
                  </Modal.Body>
                </Modal>



                <Modal
                  show={showModalGateway}
                  aria-labelledby="contained-modal-title-vcenter"
                  onHide={this.hideModalGateway}
                  centered
                  backdrop="static"
                  keyboard={false}
                >
                  <Modal.Body className='text-center p-4'>
                    <h4>Popup ถูกบล็อกโดย browser<br />กรุณากำหนดสิทธิ์ให้สามารถเปิด Popup</h4>
                    {(gatewayPayment && gatewayPayment.redirect_url) &&
                      <Button href={gatewayPayment.redirect_url} target={'_blank'}>คลิกเพื่อเข้าสู่หน้าชำระเงิน</Button>
                    }
                  </Modal.Body>
                </Modal>
              </>
            }

          </>
        ) : (<Redirect to={'/signin?path=' + pathname} />)}



      </>
    );
  }
}


const mapStateToProps = state => ({
  loading: state.loading
});

export default connect(mapStateToProps)(Deposit);